export default {
    commander: 'commander',
    informationPersonnelle: 'INFORMATION PERSONNELLE',
    informationDelivery: 'INFORMATION DE LIVRAISON',
    paymentInformation: 'INFORMATION DE PAIEMENT',
    nextStep: 'Étape suivante',
    confirmOrder: 'Confirmer la commande',
    clientConfirm: {
        orderMade: 'Commande effectuée',
        title: 'Numéro de confirmation Boires : ',
        description: 'Merci pour ta commande. <br>Tu recevras un courriel de confirmation sous peu. N\'hésite <br> pas à nous écrire à info@boires.ca si tu as des questions. <br>Santé!',
        rightTitle: 'SUIVIS DES COMMANDES',
        rightDescription: 'Le savais tu ? Tu peux faire le suivis de tes commandes et accéder à ton historique depuis la page de ton compte Boires !',
        buttonText: 'Accéder à mon compte'
    },
    guestConfirm: {
        orderMade: 'Commande effectuée',
        title: 'Numéro de confirmation Boires : ',
        description: 'Merci pour ta commande. <br>Tu recevras un courriel de confirmation sous peu. N\'hésite <br> pas à nous écrire à info@boires.ca si tu as des questions. <br>Santé!',
        rightTitle: 'SIMPLIFIEZ VOS PROCHAINES COMMANDES',
        rightDescription: 'Crée ton compte pour rentrer tes informations juste une fois! Tu pourras aussi avoir accès à ton historique de commande et de livraison.',
        buttonText: 'Créer mon compte'
    },
    pickupinstore: 'Ramassage au Boutique',
    pickupinstorePlaceholder: 'Choisir un Boutique',
    produitsdelaboutique: 'Commande de Boutique',
    produitsdeagence: "Produits de l'agence",
    boutiqueProductsSubtitle: 'Produits du boutique',
    pickUp: "A ramasser uniquement",
    produitsdeagenceText: "Chercher une succursale",
    selectBranchError: "Veuillez sélectionner une branche",
    step1: 'ÉTAPE 1/3',
    step2: 'ÉTAPE 2/3',
    step3: 'ÉTAPE 3/3',
    from: {
        firstName: 'Votre prénom est obligatoire',
        lastName: 'Votre nom est obligatoire',
        email: 'Votre courriel est obligatoire',
        phone: 'Votre téléphone est obligatoire',
        password: 'Votre mot de passe est obligatoire',
    },
    noBranchFound: "Branche introuvable",
    errorMessage1: "Error during payment process",
    errorMessage2: "An error has occurred during payment confirmation!",
};
